interface CTAProps {
  onGetQuote: () => void;
}

export default function CTA({ onGetQuote }: CTAProps) {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl md:rounded-3xl overflow-hidden relative">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{ 
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}></div>
          </div>

          <div className="relative py-10 sm:py-14 md:py-20 lg:py-24 px-5 sm:px-8 md:px-12 lg:px-16 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-5 md:mb-6 leading-tight px-2">
              Ready to Transform<br />
              Your Space?
            </h2>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/80 mb-6 sm:mb-8 md:mb-10 lg:mb-12 max-w-2xl mx-auto leading-relaxed px-4">
              Get a free consultation and quote today. Our team is ready to bring your vision to life with expert craftsmanship and attention to detail.
            </p>
            
            <button 
              onClick={onGetQuote}
              className="group inline-flex items-center gap-2 sm:gap-3 md:gap-4 bg-white hover:bg-gray-50 text-gray-900 px-5 sm:px-7 md:px-9 lg:px-10 py-3 sm:py-3.5 md:py-4 lg:py-5 rounded-full text-sm sm:text-base md:text-lg font-semibold transition-all duration-300 hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span>Get Your Free Quote</span>
              <span className="relative">
                <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-black rounded-full flex items-center justify-center group-hover:bg-[#2563EB] transition-colors duration-300">
                  <i className="ri-arrow-right-line text-lg sm:text-xl md:text-2xl text-white"></i>
                </div>
              </span>
            </button>

            <div className="mt-6 sm:mt-8 md:mt-10 lg:mt-12 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-8 md:gap-10 lg:gap-12 px-4">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl sm:text-2xl md:text-3xl text-white/80"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-white/60 uppercase tracking-wider">Call Us</div>
                  <div className="text-sm sm:text-base font-semibold text-white whitespace-nowrap">+1 (321) 947-6724</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-xl sm:text-2xl md:text-3xl text-white/80"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-white/60 uppercase tracking-wider">Response Time</div>
                  <div className="text-sm sm:text-base font-semibold text-white whitespace-nowrap">Within 24 Hours</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}